<template>
<div>
  <Form :fnoname="'910.00'" :fnoperiod="'halfyear'" :fnotitle="'Упрощенная декларация для субъектов малого бизнеса'"></Form>
</div>
</template>

<script>
import Form from "@/components/reports/Form";
export default {
  name: "Form910.00",
  components: {
    Form
  }
}
</script>

<style scoped>

</style>